// ----------------------------------------------------------------------

export default function Tabs(theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#F0F0F7',
          border: '1px solid #95A2B0',
          borderRadius: 23,
          padding: 6,
          minHeight: 40,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          borderRadius: 23,
          color: '#95A2B0',
          padding: '0 20px',
          minHeight: 40,
          height: 40,
          lineHeight: 1,
          maxWidth: '100%',

          '&.Mui-selected': {
            color: '#000',
            backgroundColor: '#fff',
            borderRadius: 23,
            borderBottom: 0,
            minHeight: 40,
            height: 40,
            lineHeight: 1,
          },

          // '&:not(:last-of-type)': {
          //   marginRight: theme.spacing(4),
          // },
          '@media (min-width: 600px)': {
            minWidth: 48,
          },
        },
        labelIcon: {
          minHeight: 40,
          flexDirection: 'row',
          '& > *:first-of-type': {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
          flexDirection: 'row',
          whiteSpace: 'nowrap',
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: '50%',
        },
      },
    },
  };
}
